import React from 'react';
import styled from '@emotion/styled';
import { withBaseLayout } from '../../layout/base-layout';
import { PlanosList } from './components';

const PlanosWhitelabel = () => {
  return (
    <Container>
      <PlanosList />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export default withBaseLayout(PlanosWhitelabel);
